import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    input: {
        '& .Mui-disabled.MuiOutlinedInput-root': {
            background: 'rgba(0,0,0,0.1)',
        },
    },
}));